// #region imports

// --- Angular
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  forwardRef,
  ViewChild,
  Input,
  Renderer2,
  ElementRef,
  EventEmitter,
  Output,
} from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

// --- 3rd Party
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';

// --- HS Code
import { SelectListItem } from '../../models';

// #endregion

@Component({
  selector: 'hs-autocomplete-dropdown',
  templateUrl: './autocomplete-dropdown.component.html',
  styleUrls: ['./autocomplete-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AutocompleteDropdownComponent),
      multi: true,
    },
  ],
})
export class AutocompleteDropdownComponent
  implements OnInit, ControlValueAccessor
{
  @Input() fieldPlaceholder: string = '';
  @Input() fieldLabel: string = '';
  @Input() noResultsLabel: string = '';
  @Input() listItems: SelectListItem[] | null = null;
  @Input() validationMessage: string = '';
  @Input() hideSearch: boolean = false;

  @Output() lostFocus = new EventEmitter();

  @ViewChild('selectItemRef', { static: true }) selectItemRef: ElementRef | undefined;
  @ViewChild('popoverRef', { static: true }) popoverRef: NgbPopover | undefined;

  selectedValue: string | undefined;

  onChange = (args: string) => {};
  onTouched = () => {};

  get selectedText(): SelectListItem {
    if (!this.listItems) return {
      text: '',
      group: '',
      isDisabled: false,
      isSelected: true,
      value: '',
    } as SelectListItem;

    const selectedItem = this.listItems.find(
      (l) => l.value === this.selectedValue
    );
    if (!selectedItem) {
      return {
        text: '',
        group: '',
        isDisabled: false,
        isSelected: true,
        value: '',
      };
    }
    return selectedItem;
  }

  constructor(private renderer: Renderer2) {}

  ngOnInit() {}

  onSelectedValueChange(selectedValue: string) {
    this.onChange(selectedValue);
    this.writeValue(selectedValue);
    this.selectedValue = selectedValue;
    this.popoverRef?.close();
    this._updateList(selectedValue);
  }

  writeValue(value: string): void {
    this._updateList(value);
    this.selectedValue = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    if (!this.selectItemRef) return;

    const select = this.selectItemRef.nativeElement;
    this.renderer.setProperty(select, 'disabled', isDisabled);
  }

  onFocus(): void {
    this.onTouched();
  }

  onBlur(): void {
    this.lostFocus.emit(this);
  }

  private _updateList(selectedValue: string): void {
    if (!this.listItems) return;

    this.listItems.forEach((l) => {
      if (l.value === selectedValue) {
        l.isSelected = true;
        return;
      }
      l.isSelected = false;
    });
  }
}
